import { BaseFeedLayout, Container, WithGradientedName } from '@/components';
import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import styles from './styles.module.scss';
import animationPreview1 from '/public/images/about/ourValueImg1.webp';
import animationPreview2 from '/public/images/about/ourValueImg2.webp';
import animationPreview3 from '/public/images/about/ourValueImg3.webp';
import animationPreview4 from '/public/images/about/ourValueImg4.webp';
import animationPreview5 from '/public/images/about/ourValueImg5.webp';
import clsx from 'clsx';
import Image from 'next/image';
export const OurValuesSection: FC = () => {
  const { t } = useTranslation('about');
  return (
    <Box component="section" className={styles.section}>
      <Container>
        <Typography variant="h2" className={styles.title}>
          <WithGradientedName text={t('ourValues.title')} lastLetterGradient />
        </Typography>
        <Box className={styles.body}>
          <BaseFeedLayout
            titleKey="ourValues.item1.title"
            textKey="ourValues.item1.text"
            variant="reverse"
            ns="about"
            colLeftClassName={styles.item1LeftCol}
            titleClassName={styles.itemTitle}
            image={
              <Box className={clsx(styles.image, styles.item1Img)}>
                <Image src={animationPreview1} alt={''} />
              </Box>
            }
          />
          <BaseFeedLayout
            titleKey="ourValues.item2.title"
            textKey="ourValues.item2.text"
            ns="about"
            colRightClassName={styles.item2ColRight}
            titleClassName={styles.itemTitle}
            image={
              <Box className={clsx(styles.image, styles.item2Img)}>
                <Image src={animationPreview2} alt={''} />
              </Box>
            }
          />
          <BaseFeedLayout
            titleKey="ourValues.item3.title"
            textKey="ourValues.item3.text"
            variant="reverse"
            ns="about"
            colLeftClassName={styles.item3LeftCol}
            titleClassName={styles.itemTitle}
            image={
              <Box className={clsx(styles.image, styles.item3Img)}>
                <Image src={animationPreview3} alt={''} />
              </Box>
            }
          />
          <BaseFeedLayout
            titleKey="ourValues.item4.title"
            textKey="ourValues.item4.text"
            ns="about"
            colRightClassName={styles.item4ColRight}
            titleClassName={styles.itemTitle}
            image={
              <Box className={clsx(styles.image, styles.item4Img)}>
                <Image src={animationPreview4} alt={''} />
              </Box>
            }
          />
          <BaseFeedLayout
            titleKey="ourValues.item5.title"
            textKey="ourValues.item5.text"
            variant="reverse"
            ns="about"
            colLeftClassName={styles.item5LeftCol}
            titleClassName={styles.itemTitle}
            image={
              <Box className={clsx(styles.image, styles.item5Img)}>
                <Image src={animationPreview5} alt={''} />
              </Box>
            }
          />
        </Box>
      </Container>
    </Box>
  );
};
